export default {"src":"/_next/static/media/freelancing.e374fca2.svg","height":284,"width":284};